import { state } from '@frameio/graphql-client';
import type { UploadApolloInput } from '../useUploadingApollo';

export const useJobRemove = () => {
  const jobRemove = ({ payload }: UploadApolloInput) => {
    const userId = 'default';
    const updatedTime = new Date().toString();
    const jobInput = payload.job;
    const userState = state.transfers.transferBatches.get(userId);
    const list = [...userState.batches];

    const indexOfJob = list.findIndex((j) => {
      return j.id === jobInput.id;
    });
    if (indexOfJob < 0) {
      return {
        error: 'Job not found',
        id: jobInput.id,
      };
    }
    const removedJobs = list.splice(indexOfJob, 1);

    state.transfers.transferBatches.set(userId, {
      batches: list,
      updatedAt: updatedTime,
    });
    return removedJobs[0];
  };

  return jobRemove;
};
